import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MovieTrailerUI from './MovieTrailerUI';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MovieTrailerUI />} />
        <Route path="/chat/:sessionId" element={<MovieTrailerUI />} />
      </Routes>
    </Router>
  );
}

export default App;
